<template>
  <div class="doorlock-log-page">
    <div class="page-search-block">
      <div class="search-bar">
        <!-- <span class="w-90 inline-block align-r m-r-8">高级筛选：</span> -->

        <div class="m-b-18 inline-block">
          <span class="w-90 inline-block align-r m-r-8">门锁编码：</span>
          <el-input class="w-200 m-r-8" v-model="filters.search.deviceCodeLike" placeholder="请输入" ></el-input>
        </div>

        <div class="m-b-18 inline-block">
          <el-select v-model="filters.search.selLabelTypeRoom" class="select-as-label w-100 m-r-8">
            <el-option key="rom1" value="roomName" label="房源名称"></el-option>
            <el-option key="rom2" value="roomCode" label="房源编码"></el-option>
          </el-select>
          <el-input class="w-120 m-r-8" v-model="filters.search.roomValue" placeholder="请输入" ></el-input>
        </div>

        <div class="m-b-18 inline-block">
          <el-select v-model="filters.search.selLabelTypeUnlocker" class="select-as-label w-100 m-r-8" >
            <el-option key="rent1" value="unlockName" label="开锁人"></el-option>
            <el-option key="rent2" value="phone" label="手机号码"></el-option>
          </el-select>
          <el-input class="w-120 m-r-8" v-model="filters.search.unlockerValue" placeholder="请输入" ></el-input>
        </div>
        <el-button class="submit-btn" size="large" @click="handleSearch()">搜 索</el-button>
      </div>
    </div>

    <div class="page-operate-block">
      <div class="tit">门锁日志列表</div>
      <div>
        <i
          class="fa icon-eye"
          :class="[hiddenNumberBol ? 'fa-eye-slash' : 'fa-eye']"
          @click="switchNumberHiddenOrShow()"
        ></i>
        <el-popover placement="bottom" trigger="click" popper-class="r-popover">
          <el-checkbox
            :indeterminate="isIndeterminate"
            v-model="checkAll"
            @change="handleCheckAllChange"
            >全选</el-checkbox
          >
          <br />
          <el-checkbox
            v-for="(column, index) in tableColumn"
            v-model="column.visible"
            :key="index"
            @change="_checkChange"
            >{{ column.label }}</el-checkbox
          >
          <template #reference>
            <el-button
              class="operate-btn"
              name="dataSetting"
              >数据项</el-button
            >
          </template>
        </el-popover>
      </div>
    </div>

    <div class="table-list-block">
      <r-table
        :ref="tableVarity"
        :columns="tableColumn"
        :dataSource="tableData"
        :options="options"
        :pagination="pagination"
        @current-change="handlePageChange"
      ></r-table>
    </div>

    <el-image-viewer v-if="showViewer" class="capture-big-image" :on-close="closeViewer" :url-list="captureSrcList" />
    <RModal
      customClass="bigModalDialog"
      title="开锁照片"
      top="5vh"
      :show="showModal"
      :closeOnClick="false"
      width="1202px"
      @change="showModal = false"
      @close="showModal = false"
    >
      <template #content>
        <ImageView :log-data="selectedRow" />
      </template>
    </RModal>

  </div>
</template>

<script>
import RModal from "@/components/common/RModal"
import RTable from '@/components/common/RTable'
import tableMix from '@/components/common/tableListMixin.js'
import checkMix from '@/components/common/checkAll.js'
import ImageView from './imgViewDialog.vue'
import { ElImageViewer } from 'element-plus'

export default {
  name: 'equipDoorlockLogPage',
  mixins: [tableMix, checkMix],
  components: { RModal,RTable,ElImageViewer,ImageView },
  data() {
    let searchData = { storeId:'','deviceCodeLike':'','selLabelTypeRoom':'roomName','roomValue':'','selLabelTypeUnlocker':'unlockName','unlockerValue':''}
    return {
      showModal: false,
      selectedRow: {},

      tableVarity: 'equiplog_doorlock_log',
      showViewer:false,
      captureSrcList:['http://10.10.109.103:5569/saas/upgradePackage/house/反2.jpg','http://10.10.109.103:5569/saas/upgradePackage/house/09.jpg'],
      tableColumn: [],
      tableData: [],
      options: {
        multiSelect: true, // 多选
        serialNum: false, // 显示序号
        loading: false, // 加载中状态
        initTable: true, // 是否一挂载就加载数据
        height: 'calc(100vh - 295px)',
        mutiSelect: true,
        selection: [],
      },
      pagination: {
        total: 0,
        pageIndex: 1,
        pageSize: 20,
      },
      // 查询参数
      filters: { search: {...searchData} },
      filtersInitSearchData:{...searchData},
      selOptions: {
        certType:[],
        unlockType: [],
      },
      selOptionMaps: {unlockType: {}},

      hiddenNumberBol: true,

      /**
       * 字段的加密形式
       * pre: 字符串的前面保留几位原始数据
       * star: 字符串的中间有几个 *
       * tail: 字符串后边保留几位原始数据
       * 比如手机：13112345678  { pre: 3, star: 4, tail: 4 } 为：131****5678
       */
      encryList: {
        unlockName: { pre: 1, star: 2, tail: 0 },
        managerName: { pre: 1, star: 2, tail: 0 },
        phone: { pre: 3, star: 4, tail: 4 },
        idNumber: { pre: 6, star: 8, tail: 4 },
      }
    }
  },
  beforeUnmount() {
    this.$eventBus.off('change-shop')
  },
  beforeRouteLeave(){
    this.$eventBus.off('change-shop')
  },
  created() {
    this.$eventBus.on('change-shop', store => {
      this.$nextTick(()=>{
        this.handleSearch()
      })
    })

    this.initTableColumns()
    this.getDictData('unlockType', 'unlockType')
  },
  
  methods: {
    // 获取字典数据
    getDictData(type, prop) {
      let url = 'RESOURCE.QUERY_DICTS_LIST'
      this.fetchData({
        url,
        method: 'get',
        params: {
          types: type
        },
        flag:true
      }).then( res => {
        
        this.selOptions[prop] = res.data[type]
        let maps = {}
        res.data[type].map((obj)=>{
          maps[obj.name] = obj.value
        })
        this.selOptionMaps[prop] = maps
      }).finally(() => {
        this.getDataList(false)
      })

    },
    // 查询列表数据
    getQuery() {
      this.options.loading = true
      let params = this.getQueryListParams()
      if(params.selLabelTypeRoom && params.roomValue){
        params[params.selLabelTypeRoom] = params.roomValue
      }

      if(params.selLabelTypeUnlocker && params.unlockerValue){
        params[params.selLabelTypeUnlocker] = params.unlockerValue
      }

      let curStoreInfo = this.getCurStoreInfo()
      if(curStoreInfo && curStoreInfo.id){
        params['storeId'] = curStoreInfo.id
      }
      console.log(curStoreInfo,curStoreInfo.id)

      delete params.selLabelTypeRoom
      delete params.roomValue
      delete params.selLabelTypeUnlocker
      delete params.unlockerValue

      let url = 'DEVICE.GET_LOCK_LOG_LIST'
      this.fetchData({
        url,
        method: 'get',
        params,
      }).then((res) => {
          this.options.loading = false
          if (this.toExcel == true) {
            if (!res || !res.data) {
              this.$message.error('操作失败！')
            } else {
              window.location.href = res.data
            }
            this.toExcel = false
            return
          }

          if (!res || !res.data) {
            this.tableData = []
            this.pagination.total = 0
          } else {
            this.tableData = res.data || []
            this.pagination.total = res.rowCount
          }
        })
        .catch((err) => {
          console.log(err, 'errorInfo')
        })
        .finally(() => {
          this.options.loading = false
          this.toExcel = false
        })
    },

    // 初始化自定义表头
    initTableColumns() {
      // 需要加密的字段的加密方式
      let encryList = this.encryList
      // 表头 visible：默认可见；isInput：表头是否输入框；isSelect：表头是否下拉框
      let columns = [
        { prop: 'unlockName', label: '开锁人', visible: true, minWidth: 100, isInput: true },
        { prop: 'certType', label: '证件种类', visible: false, minWidth: 100, isSelect: true },
        { prop: 'idNumber', label: '证件号码', visible: false, minWidth: 160, isInput: true },
        { prop: 'phone', label: '手机号码', visible: true, minWidth: 160, isInput: true },
        { prop: 'unlockType', label: '开锁方式', visible: true, minWidth: 160, isSelect: true },
        { prop: 'unlockTime', label: '开锁时间', visible: true, minWidth: 160 },
        { prop: 'deviceCode', label: '门锁编码', visible: true, minWidth: 160, isInput: true },
        { prop: 'managerName', label: '经营者名称', visible: true, minWidth: 160, isInput: true },
        { prop: 'roomName', label: '房源名称', visible: true, minWidth: 160, isInput: true },
        { prop: 'roomCode', label: '房源编码', visible: false, minWidth: 160, isInput: true },
        { prop: 'roomNum', label: '房间号', visible: false, minWidth: 160, isInput: true },
        { prop: 'roomAddress', label: '房源地址', visible: true, minWidth: 160, isInput: true },
        { prop: 'orderCode', label: '订单编码', visible: false, minWidth: 160, isInput: true },
        { prop: 'orgName', label: '门锁厂商', visible: false, minWidth: 160, isInput: true },
        { prop: 'deviceModel', label: '门锁型号', visible: false, minWidth: 160, isInput: true },
        { prop: 'createTime', label: '入库时间', visible: true, minWidth: 160 },
        { prop: 'operate', label: '开锁照片', visible: true, minWidth: 160 },        
      
      ]

      columns.forEach((item) => {
        if (item.prop === 'unlockType') {
          item.render = (row, index, column) => {
            let unlockTypes = this.selOptionMaps.unlockType
            return <span>{unlockTypes[row[item.prop]]?unlockTypes[row[item.prop]]:row[item.prop]}</span>
          }
        }else if(item.prop === 'certType'){
          item.render = (row, index, column) => {
            return <span>身份证</span>
          }
        }else if(item.prop == 'unlockName' || item.prop == 'phone' || item.prop == 'idNumber' || item.prop=='managerName'){
          item.render = (row, index, column) => {
            let text = this.encryData(row[column.prop], encryList[item.prop])
           return <span>{text}</span>
          }
        }else if(item.prop === 'orgName'){
          item.render = (row, index, column) => {
            return <span>瑞为技术</span>
          }
        }else if(item.prop === 'operate'){
          item.render = (row, index, column) => {
            if (!row.captureRecordDTOList) {
              return <span style="color:#909399">没有开锁照片</span>
            }
            return (
              <a onClick={ this.handleShowImg.bind(this, row) }>
                点击查看
              </a>
            );
          }
        }else{
          item.render = (row, index, column) => {
            return <span>{(row[item.prop]==''||row[item.prop]===undefined)?'--':row[item.prop]}</span>
          }
        }
      })

      this.tableColumn = columns
    },
    backToLock() {
      this.$emit('change-view')
    },
    // 打开弹框显示图片
    handleShowImg(data) {
      this.showModal = true
      this.selectedRow = data
    },
    //门铃抓拍记录
    goToCapture(){
      this.options.loading = true
      let url = 'SAAS.DOOR_BELL_LOG'
      
      let params = {params: JSON.stringify({"deviceNum":this.options.selection[0].deviceCode,"opTime":this.options.selection[0].opTime})}
      this.fetchData({
        url,
        method: 'post',
        params,
      })
      .then((res) => {
        this.options.loading = false
        if (!res || !res.data || !res.data.length) {
          this.$message.error('暂无数据！')
        } else {
          this.showViewer = true
          let captureSrcList = []
          res.data.length && res.data.forEach(item=>{
            captureSrcList.push(item.faceUrl)
          })
          this.captureSrcList = captureSrcList
        }
      })
      .catch((err) => {
        console.log(err, 'errorInfo')
      })
      .finally(() => {
        this.options.loading = false
      })
      
    },
    
    //关闭抓拍
    closeViewer(){
      this.showViewer = false
    },

    // 对数据进行加密
    encryData(text, encry) {
      if (!text) return ''
      if (!this.hiddenNumberBol) return text
      if (text.length < (encry.pre + encry.tail)) return text

      let preText = text.substr(0, encry.pre)
      if (encry.pre === 0) {
        preText = ''
      }
      let star = ''
      for (let i = 0; i < encry.star; i++) {
        star += '*'
      }
      let tailText = text.substr(-encry.tail)
      if (encry.tail === 0) {
        tailText = ''
      }
      return preText + star + tailText
    },

    // 切换敏感信息加密状态
    switchNumberHiddenOrShow() {
      this.hiddenNumberBol = !this.hiddenNumberBol;
    },
  }
}
</script>

<style lang="less" scoped>
.doorlock-log-page{
  padding-bottom: 5px;
}
.el-form-item{
  width: 300px !important;
}
.log-title {
  font-size: 22px;
  font-weight: 600;
}
.capture-big-image {
  z-index:10001 !important;
}
</style>
